import BaseModel    from '@/lib/data/model/BaseModel'
import VoteResource from '@/api/resources/home/VoteResource'

export default class VoteModel extends BaseModel {
  constructor (payload = {}, resource = VoteResource, validator = null) {
    super(payload, resource, validator)
  }

  boot () {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
